module.exports = __webpack_public_path__ + "static/the-4hour-work-week-5321b69186ef48084c38ba37df8309fb.jpg";